import {useState} from 'react';
import {twMerge} from 'tailwind-merge';
import type {ImageModel} from '@/types/content';

import {getGroupedImageMedia, getImageMedia, isDefaultMedia} from './RemoteImage.helpers';

type Props = {
    imageMedia?: ImageModel[];
    className?: string;
    imgClassName?: string;
};

const RemoteImage = ({imageMedia, className, imgClassName}: Props) => {
    const [hasError, setHasError] = useState(false);

    if (!imageMedia?.length || hasError) return null;

    const groupedImageMedia = getGroupedImageMedia(imageMedia);
    const defaultImageMedia = groupedImageMedia.find((x) => isDefaultMedia(x))?.item;

    if (!defaultImageMedia?.length) return null;

    const defaultImageSet = getImageMedia(defaultImageMedia);
    const otherImageMedia = groupedImageMedia
        .filter((x) => !isDefaultMedia(x))
        .sort((a, b) => parseInt(String(b.key), 10) - parseInt(String(a.key), 10));

    const defaultImage = defaultImageMedia[0];
    const alt = defaultImage?.alt;

    return (
        <picture className={className}>
            {otherImageMedia.map((media) => {
                const {key, item} = media || {};

                if (key === undefined || key === null || !item) return null;

                const maxWidth = item[0]?.viewport?.maxWidth;
                const mediaWidth = maxWidth
                    ? `(min-width: ${String(key)}px) and (max-width: ${String(maxWidth)}px)`
                    : `(min-width: ${String(key)}px)`;

                return <source key={String(key)} srcSet={getImageMedia(item)} media={mediaWidth} />;
            })}
            <img
                className={twMerge(className, imgClassName)}
                src={defaultImage?.path}
                srcSet={defaultImageSet}
                alt={alt}
                onError={() => setHasError(true)}
            />
        </picture>
    );
};

export default RemoteImage;
